<template>
  <div class="basic-block block-sns-share">
    <div class="content-wrap">
      <div class="block-sns-share__inner">
        <p class="block-sns-share__lead">{{ targetInfo.snsShare.lead }}</p>
        <div class="snsBtns">
          <a @click.prevent="clickLine" class="snsBtns__btn snsBtns__btn--line">
            <img src="/static/img/common/sns_icon_line.svg" width="27" class="snsBtns__img snsBtns__img--line">LINEで送る
          </a>
          <a @click.prevent="clickTwitter" class="snsBtns__btn snsBtns__btn--twitter">
            <img src="/static/img/common/sns_icon_twitter.svg" width="19" class="snsBtns__img snsBtns__img--twitter">ツイート
          </a>
          <a @click.prevent="clickFacebook" class="snsBtns__btn snsBtns__btn--facebook">
            <img src="/static/img/common/f_logo_RGB-White_250.png" width="19" class="snsBtns__img snsBtns__img--facebook">シェア
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockSnsShare',
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    shareLineData: {
      type: String,
      efault: '',
    },
    shareTwitterData: {
      type: String,
      default: '',
    },
    resultShareWords: {
      type: String,
      default: '',
    },
    resultShareUrl: {
      type: String,
      default: '',
    },
    resultShareCpno: {
      type: String,
      default: '',
    },
    lpId: Number,
  },
  computed: {
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
    encodedUrls(){
      const urlobj = new URL(this.resultShareUrl)
      const url = `${urlobj.origin}${urlobj.pathname}`
      const sep = url.split('?')
      return {
        origin: sep[0],
        base: sep[0],
        params: !!sep[1] ? `?${sep[1]}` : '',
        encodedParams: encodeURIComponent(`?${sep[1]}`),
        encodedOrigin: encodeURIComponent(url)
      }

    },
    twitterLinkStr() {
      const res = `https://twitter.com/share?url=${this.encodedUrls.encodedOrigin}&text=${ encodeURIComponent(this.resultShareWords) }%0a&hashtags=${this.targetInfo.name}`
      return res
    },
    lineLinkStr() {
      return `http://line.me/R/msg/text/?${ encodeURIComponent(this.resultShareWords) }%20${ this.encodedUrls.encodedOrigin }`
    },
    facebookLinkStr() {
      return `http://www.facebook.com/share.php?u=${ this.encodedUrls.encodedOrigin }`
    }
  },
  methods: {
    clickLine() {
      this.sendGa('LINE')
      window.open(this.lineLinkStr, '_blank');
    },
    clickTwitter() {
      this.sendGa('Twitter')
      window.open(this.twitterLinkStr, '_blank');
    },
    clickFacebook() {
      this.sendGa('Facebook')
      window.open(this.facebookLinkStr, '_blank');
    },
    sendGa(label) {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}basicresult-SNSshare-button`,
        'event_label': label,
      })
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
.block-sns-share {
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  background: #FFFBE3;
  padding: 0 0 20px;
  &__inner {
    margin: 0 20px;
    padding: 20px 16px 24px;
    background: #fff;
  }
  &__lead {
    margin: 0 0 16px;
    font-weight: bold;
    font-size: 16px;
    line-height: 12px;
    text-align: center;
    letter-spacing: 1px;
  }
}
.snsBtns {
  display: flex;
  justify-content: space-around;
  &__btn {
    display: block;
    border-radius: 5px;
    max-width: 180px;
    font-size: 10px;
    font-weight: bold;
    color: #fff;
    padding: 0;
    height: 35px;
    line-height: 35px;
    text-align: center;
    text-decoration: none;
    flex: 1 1 auto;
    margin-right: 5px;
    &:last-child {
      margin-right: 0;
    }
    &--twitter { background: #1fa0f2; }
    &--line { background: #00b901; }
    &--facebook { background: #1877f2;}
  }
  &__img {
    vertical-align: middle;
    margin: -3px 6px 0 0;
    &--twitter { }
    &--line { margin-left: -3px; }
    &--facebook { }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/blocks/BlockSnsShare.vue